import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ToastrHelper } from '../../../helpers/toastr.helper';
import { EventAccessTypeEnum, EventAccessTypeEnumLabelMap } from '../../../models/events/event-access-type.enum.model';
import { EventFilters } from '../../../models/events/event-filters.model';
import { EventTypeEnum, EventTypeEnumLabelMap } from '../../../models/events/event-type.enum.model';
import { Event } from '../../../models/events/event.model';
import { EventsService } from '../../../services/events/events.service';
import { AccountsService } from '../../../services/identity/accounts.service';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { User } from '../../../models/identity/user.model';

@Component({
    selector: 'app-widget-event',
    templateUrl: './widget-event.component.html',
    styleUrls: ['widget-event.component.scss'],
})
export class WidgetEventComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    public events: Event[] = [];
    public today: Date = new Date();

    public joinEventDialog = false;

    public numberOfEventsToDisplay = 5;
    public isLoading = true;

    constructor(
        private readonly toastrHelper: ToastrHelper,
        private readonly eventsService: EventsService,
        private router: Router,
        private readonly accountService: AccountsService,
    ) {}

    public ngOnInit() {
        this.loadEvent();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public loadEvent(): void {
        const currentUser: User = this.accountService.currentUser;

        const myFilter: EventFilters = {
            page: 1,

            isMyOrganizationChecked: false,
            organizationId: null,

            isAllMyCommunitiesChecked: false,
            communitiesIds: currentUser.communities.map((community) => community.id),

            isAllCommunitiesChecked: false, //commu cloisonées
            accessTypes: [],
            types: [],

            search: '',
        };

        this.eventsService
            .getFilteredEvents(myFilter)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (events) => {
                    this.events = events.filter((event) => this.eventIsJoinable(event, currentUser));
                    this.events = this.events.slice(0, this.numberOfEventsToDisplay);
                    this.isLoading = false;
                },
                (error) => {
                    this.toastrHelper.showGenericError(error);
                    this.isLoading = false;
                },
            );
    }

    public eventIsJoinable(event: Event, user: User): boolean {
        return event.owner.id !== user.userId && !event.attendees.some((attendee) => attendee.id === user.userId);
    }

    public userJoinedEvent() {
        this.loadEvent();
    }

    public defineCountDown(eventStartDate: string): number {
        return Math.floor((this.today.getTime() - new Date(eventStartDate).getTime()) / (1000 * 60 * 60 * 24));
    }

    public getTypeLabel(typeId: number): string {
        return EventTypeEnumLabelMap[typeId as EventTypeEnum];
    }

    public getAccessType(typeId: number): string {
        return EventAccessTypeEnumLabelMap[typeId as EventAccessTypeEnum];
    }

    public goToEventPage(eventId: string): void {
        this.router.navigate(['events', eventId]);
    }

    public isEventWithExternalLink(event: Event): boolean {
        return Event.isExternalEvent(event);
    }

    public goToEventExternalLink(event: Event): void {
        this.closeJoinEventDialog();
        window.open(event?.registrationLink, '_blank');
    }

    public openJoinEventDialog(): void {
        this.joinEventDialog = true;
    }

    public closeJoinEventDialog(): void {
        this.joinEventDialog = false;
    }
}
